export default __webpack_public_path__ + "static/media/macaw-gaming.951c4f81.png";